import cn from 'classnames';
import Link from 'next/link';
// Types
import { GetAffiliateStreamProducts_getAffiliateStreamProducts } from 'api/streams/types/GetAffiliateStreamProducts';
// Helpers
import {
  formatCurrencyString,
  formatCurrencyStringWithoutName,
} from 'helpers/formatCurrencyString';
// Ui
import Image from 'ui/Image/Image';
import LinkButton from 'ui3/LinkButton/LinkButton';
// Styles
import styles from './AffiliateProductItem.module.scss';

type AffiliateProductItemProps = {
  affiliateProduct: GetAffiliateStreamProducts_getAffiliateStreamProducts;
  theme?: Theme;
};

const AffiliateProductItem = ({
  affiliateProduct,
  theme = 'white',
}: AffiliateProductItemProps) => {
  const { price, url, title, imageUrl } = affiliateProduct;

  const formattedPrice = formatCurrencyStringWithoutName(price);
  const priceWithCurrency = formatCurrencyString(price);

  return (
    <div
      className={cn(styles.root, 'baseCardRoot', {
        [styles[`theme-${theme}`]]: theme,
      })}
    >
      <Link href={url || ''} prefetch={false}>
        <a
          className={styles.imageLink}
          title={title}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={styles.imageWrapper}>
            <div className={styles.bannerWrapper}>
              <div className={styles.banner}>{formattedPrice}</div>
            </div>

            <Image
              src={imageUrl}
              alt={title}
              layout="fill"
              objectFit="cover"
              objectPosition="center center"
              sizes="25vw"
            />
          </div>
        </a>
      </Link>

      <div className={styles.content}>
        <p className={styles.title} title={title}>
          {title}
        </p>
        <div className={styles.buttonWrapper}>
          <LinkButton
            link={url || ''}
            variant="secondary"
            subVariant="outlined"
            size="medium"
            className={cn(styles.viewButton, 'buyNowButton')}
            target="_blank"
            rel="noopener noreferrer"
          >
            View - {priceWithCurrency}
          </LinkButton>
        </div>
      </div>
    </div>
  );
};

export default AffiliateProductItem;
